import React from "react";

const ReportForm = () => <h1>Submit a Report</h1>;

export default ReportForm;
